const fields = [
  {
    key: 'check',
    label: 'Check'
  },
  {
    key: 'contrato',
    label: 'Contrato'
  },
  {
    key: 'patente',
    label: 'Patente'
  },
  {
    key: 'marca',
    label: 'Marca'
  },
  {
    key: 'modelo',
    label: 'Modelo'
  },
  {
    key: 'fechaInicio',
    label: 'Fecha Inicio'
  },
  {
    key: 'fechaTermino',
    label: 'Fecha Devolución'
  },
  {
    key: 'plazo',
    label: 'Plazo'
  },
  {
    key: 'tarifa',
    label: 'Tarifa'
  },
  {
    key: 'asignacion',
    label: 'Asignación'
  },
  {
    key: 'residencia',
    label: 'Residencia'
  },
  {
    key: 'gps',
    label: 'GPS'
  },
  {
    key: 'klmtrosRecorridos',
    label: 'Kilometraje'
  },
  {
    key: 'revisionTecnica',
    label: 'Revision Tecnica'
  },
  {
    key: 'documentacion',
    label: 'Documentacion del vehiculo'
  }
];

module.exports = {
  fields
}
